




import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({
  components: {
    RelativeProfileForm: () =>
      import('@/components/patient/profileForm/RelativeProfileForm.vue')
  }
})
export default class RelativeProfileEdit extends Vue {
  $store!: ExStore

  get relativeInfo() {
    return this.editingInputs || this.$store.getters['user/relativeInfo']
  }

  get editingInputs() {
    return this.$store.getters['user/sessionData']('relativePatchPayload')
  }

  async created() {
    if (!this.editingInputs) {
      await this.$store.dispatch('user/updateRelativeInfo')
    }
  }
}
